import { WidgetAutocheck } from "@redotech/redo-model/widget";
import * as sortBy from "lodash/sortBy";
import { RedoCheckboxElement } from "./checkbox-app";
import { CONCIERGE_PRODUCT_FORM_CONTAINER_ID } from "./concierge/initializer";
import { RedoEstimateElement } from "./delivery-estimate-app";
import { BACK_IN_STOCK_PDP_BUTTON_CONTAINER_ID } from "./product-back-in-stock/initializer";
import "./styles.css";

void import("./styles.global.css");

const CHECKBOX_CONTAINER_ID = "redo-checkbox";
const ESTIMATE_CONTAINER_ID = "redo-estimate";

const FORM_SELECTOR =
  '[action="/cart/add"]:not(#product-form-installment):not(.installment)';

export const TAPCART_SELECTOR = "#redo_tapcart_container";

function addContainer(
  widgetId: string,
  autocheck: WidgetAutocheck,
  onTapcart: boolean,
  containerId: string,
) {
  if (!autocheck.enabled) {
    return;
  }
  const selector = onTapcart
    ? TAPCART_SELECTOR
    : autocheck.selector || FORM_SELECTOR;
  const forms = document.querySelectorAll(selector);
  const sortedForms = sortBy(
    forms,
    (form) =>
      !form.querySelector('button[type="submit"], input:not([type="hidden"])'),
  );
  // They have an identical form that is invisible, so we need to select 2nd form
  const form = onTapcart
    ? sortedForms[0]
    : sortedForms[Shopify?.shop === "palmdancewear.myshopify.com" ? 1 : 0];
  if (!form) {
    return;
  }
  const container = document.createElement("div");
  container.id = containerId;
  form.appendChild(container);
  return container;
}

export function addCheckbox(
  autocheck: WidgetAutocheck,
  onTapcart: boolean,
): RedoCheckboxElement | null {
  const container =
    document.getElementById(CHECKBOX_CONTAINER_ID) ||
    addContainer(
      window.redoWidgetId,
      autocheck,
      onTapcart,
      CHECKBOX_CONTAINER_ID,
    );
  if (!container) {
    return null;
  }

  RedoCheckboxElement.register();

  const checkbox = document.createElement(
    RedoCheckboxElement.TAG,
  ) as RedoCheckboxElement;

  container.append(checkbox);

  return checkbox;
}

export function addEstimate(
  autocheck: WidgetAutocheck,
  onTapcart: boolean,
): RedoEstimateElement | null {
  const container =
    document.getElementById(ESTIMATE_CONTAINER_ID) ||
    addContainer(
      window.redoWidgetId,
      autocheck,
      onTapcart,
      ESTIMATE_CONTAINER_ID,
    );
  if (!container) {
    return null;
  }

  RedoEstimateElement.register();

  const estimate = document.createElement(
    RedoEstimateElement.TAG,
  ) as RedoEstimateElement;

  container.append(estimate);

  return estimate;
}

export function addBackInStockPdpButton(
  autocheck: WidgetAutocheck,
  onTapcart: boolean,
) {
  const container =
    document.getElementById(BACK_IN_STOCK_PDP_BUTTON_CONTAINER_ID) ||
    addContainer(
      window.redoWidgetId,
      autocheck,
      onTapcart,
      BACK_IN_STOCK_PDP_BUTTON_CONTAINER_ID,
    );
  if (!container) {
    return null;
  }

  // Shopify applies display: none to empty divs
  (container as HTMLElement).style.display = "unset";

  return container;
}

export function addConciergeProductForm(
  autocheck: WidgetAutocheck,
  onTapcart: boolean,
) {
  const container =
    document.getElementById(CONCIERGE_PRODUCT_FORM_CONTAINER_ID) ||
    addContainer(
      window.redoWidgetId,
      autocheck,
      onTapcart,
      CONCIERGE_PRODUCT_FORM_CONTAINER_ID,
    );

  if (!container) {
    return null;
  }

  return container;
}
